var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#FDF4E5",
    stroke: "#FFF6E5",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 8.10714 0.00210637 8.2138 0.00627995 8.31992C0.174209 4.04995 3.68887 0.639844 8 0.639844C12.3111 0.639844 15.8258 4.04995 15.9937 8.31992C15.9979 8.2138 16 8.10714 16 8C16 3.58172 12.4183 0 8 0Z",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 7.89282 15.9979 7.78614 15.9937 7.67999C15.8257 11.9499 12.3111 15.36 8 15.36C3.6889 15.36 0.174255 11.9499 0.00628544 7.67997C0.00210929 7.78613 1.66243e-06 7.89282 1.65306e-06 8C1.2668e-06 12.4183 3.58172 16 8 16Z",
    fill: "black"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#FDF4E5",
    stroke: "#FFF6E5",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 8.10714 0.00210637 8.2138 0.00627995 8.31992C0.174209 4.04995 3.68887 0.639844 8 0.639844C12.3111 0.639844 15.8258 4.04995 15.9937 8.31992C15.9979 8.2138 16 8.10714 16 8C16 3.58172 12.4183 0 8 0Z",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 7.89282 15.9979 7.78614 15.9937 7.67999C15.8257 11.9499 12.3111 15.36 8 15.36C3.6889 15.36 0.174255 11.9499 0.00628544 7.67997C0.00210929 7.78613 1.66243e-06 7.89282 1.65306e-06 8C1.2668e-06 12.4183 3.58172 16 8 16Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 4.16675L9.20363 6.15861L9.31625 6.34497L9.5294 6.38946L11.8319 6.87004L10.2733 8.55137L10.119 8.71781L10.1427 8.94353L10.3806 11.2079L8.19542 10.2798L7.99995 10.1968L7.80449 10.2798L5.61935 11.2079L5.85722 8.94353L5.88093 8.71781L5.72663 8.55137L4.16796 6.87004L6.4705 6.38946L6.68365 6.34497L6.79627 6.15861L7.99995 4.16675Z",
    fill: "url(#paint0_linear)",
    stroke: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.99995,
    y1: 3.2,
    x2: 7.99995,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 7.99995,
    y1: 3.2,
    x2: 7.99995,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityHeaderIcon);
export default __webpack_public_path__ + "static/media/security_header_icon.b51559560718db9e1aeba0b3bdaba6a3.svg";
export { ForwardRef as ReactComponent };